exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._9DDgb{position:relative;padding:20px 15px;background-color:#fff;font-weight:400;margin-bottom:30px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1)}._3PEir{display:block;font-weight:700;font-size:20px;color:#000;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"root": "_9DDgb",
	"title": "_3PEir"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/home/components/CarCostEstimate/CarCostEstimate.css
// module id = 2911
// module chunks = 33